import { render } from "./main-cart.vue?vue&type=template&id=9d6c1242&scoped=true"
import script from "./main-cart.vue?vue&type=script&lang=js"
export * from "./main-cart.vue?vue&type=script&lang=js"

import "./main-cart.vue?vue&type=style&index=0&id=9d6c1242&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d6c1242"]])

export default __exports__